import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';

import { Switch, Route, Router, Redirect } from 'react-router-dom';
import { history } from 'easit--routing';
import * as routing from './liveRouting';
import { errorIsCancel, ConnectionStatus, ProgressStateModel, OfferType, devLogService } from 'eTip--common';
import * as stores from './liveStores';

import { ErrorBoundary, IErrorBoundaryLoggerService } from './errorBoundary';
import { LeftMenuContainer } from './containers/liveLeftMenu/leftMenuContainer';
import { EventListRoute } from './containers/liveEventList/eventListRoute';
import { EventDetailRouteContainer } from './containers/liveEventDetail/eventDetailRoute';
import { FavoriteDetailsRouteContainer } from './containers/liveFavoriteEventDetails/favoriteDetailsRoute';
import { CalendarRouteContainer } from './containers/liveCalendar/calendarRoute';
import { RightColumnTicketAreaWrapper } from './containers/ticket/rightColumnTicketAreaWrapper';
import { LiveTicketListContainer } from './containers/ticketList/liveTicketListContainer';
import { MatchTrackerWithSelection } from './containers/liveStream/matchTrackerWithSelection';
import {
    TicketDetailMyTicketLiveContainer, TicketDetailPublicTicketLiveContainer,
    TicketDetailTicketByNumberLiveContainer, TicketDetailLegacyPublicTicketLiveContainer
} from './containers/routes/ticketDetailLiveContainer';
import { FindTicketByNumberContainer } from './containers/findTicketByNumber/findTicketByNumberContainer';
import { ChatContainer } from './containers/chat/chatContainer';
import { SearchContainer } from './containers/routes/searchRoute';

import { DevLog, OfflinePage } from 'common--design-library';
import { SimpleBarWrapper as SimpleBar, TopNavigation, SoundSelection, IMatchTrackerSelectionItem, MobileAppLinkAdvert } from 'desktop--design-library';
import { LiveTicketListForVGContainer } from './containers/ticketListForVG/liveTicketListForVGContainer';
import { LiveTicketDetailMyTicketForVGContainer } from './containers/routes/ticketDetailForVGLiveContainer';
import { LegacyBetDetailLiveRoute, LegacyPublicBetDetailLiveRoute } from './containers/routes/betDetailRoute';
import { MarketingActionContainer } from './containers/marketingAction/marketingActionContainer';
import { RightBannersContainer } from './containers/rightBanner/rightBannersContainer';
import { pushToTicketDetail, pushToTicketDetailByNumber } from './liveRouting';
import { LiveTicketWinListContainer } from './containers/ticketList/liveTicketWinListContainer';

let hacks = require('viewport-units-buggyfill/viewport-units-buggyfill.hacks');
require('viewport-units-buggyfill').init({
    hacks: hacks
});
//require('viewport-units-buggyfill').init();

interface IAppProps {
    applicationStore?: Instance<typeof stores.ApplicationStore>;
}

@inject(stores.ApplicationStoreKey)
@observer
export class App extends React.Component<IAppProps> {

    private refreshEventsTimer: number = null;
    private isUnmounted = false;

    private errorBoundaryLoggingService: IErrorBoundaryLoggerService = {
        logError: (error: Error, info: Object) => {
            this.store.saveError(error, info, true);
        }
    }

    componentDidMount() {
        // if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
        //     viewportUnitsBuggyfill.init();
        // }
        // viewportUnitsBuggyfill.init();
        window.addEventListener('resize', this.props.applicationStore.screenInfo.init);

        this.eventsStore.initAsync(() => { return new Set<number>(this.store.favoriteEventInfos.map(v => v.eventId)); })
            .then(() => {
                this.store.checkFavoriteIds(true);
                if (!this.store.canShowLeftColumn) { //means showing event list
                    if (!this.store.screenInfo.isXxlDown) {  //same in event list mount
                        this.store.events.checkAndOpenDetail();
                    }
                }
                this.planRefreshEvents();
            });
    }

    private planRefreshEvents = () => {
        if (this.isUnmounted) {
            return;
        }
        if (this.refreshEventsTimer != null) {
            return;
        }
        if (this.eventsStore.state != ProgressStateModel.Success) {
            return;
        }
        this.refreshEventsTimer = window.setTimeout(() => {
            try {
                this.refreshEventsTimer = null;
                this.eventsStore.reloadDataAsync(() => { return new Set<number>(this.store.favoriteEventInfos.map(v => v.eventId)); })
                    .then(() => {
                        this.store.checkFavoriteIds(false);
                        this.planRefreshEvents();
                    })
                    .catch((reason) => {
                        if (!errorIsCancel(reason)) {
                            this.planRefreshEvents();
                        }
                    });
            }
            catch (e) {
                this.props.applicationStore.loggingService.error(e);
                this.planRefreshEvents();
            }
        }, this.eventsStore.refreshTime);
    }

    get store() {
        return this.props.applicationStore;
    }

    get eventsStore() {
        return this.props.applicationStore.events;
    }

    render() {
        const paths = routing.paths();
        return (
            <Router history={history()}>
                <ErrorBoundary onContinueClick={() => { location.reload() }} errorLoggingService={this.errorBoundaryLoggingService} >
                    {/*<NotificationDialog /> TODOHX */}
                    {this.store.connectionStatus == ConnectionStatus.Disconnected.toString() && <OfflinePage isLoading={this.store.isOfflineCheckInProgress} onCheck={() => { this.store.checkOfflineAsync(); }} />}
                    <div className="d-flex">
                        {this.props.applicationStore.canShowLeftColumn &&
                            <SimpleBar
                                className={`live-tree-container scroll-container hide-x-bar ${this.store.isLeftColumnCollapsed ? 'tree-collapsed' : ''}`}
                                forceVisible={true} scrollToTop>
                                <LeftMenuContainer
                                    events={this.props.applicationStore.events}
                                    isLeftColumnCollapsed={this.props.applicationStore.isLeftColumnCollapsed}
                                    search={this.props.applicationStore.search}
                                    ticketWrapper={this.props.applicationStore.ticketWrapper}
                                    setCategoryAsFavorite={this.props.applicationStore.setCategoryAsFavorite}
                                    setEventIsFavorite={this.props.applicationStore.setEventIsFavorite}
                                    toggleLeftColumnExpand={this.props.applicationStore.toggleLeftColumnExpand}
                                />
                            </SimpleBar>
                        }
                        <div className="flex-grow-1 scroll-container live-center-container" >
                            <TopNavigation
                                soundSelection={<SoundSelection
                                    isMute={this.props.applicationStore.soundUI.isMute}
                                    toggleIsMute={() => { this.props.applicationStore.soundUI.setIsMute(!this.props.applicationStore.soundUI.isMute); }}
                                />}
                                paths={{
                                    home: paths.home,
                                    liveEvent: paths.genericEventDetail,
                                    favorites: paths.favoriteDetails,
                                    calendar: paths.calendar
                                }}
                                entrancePageGlobalRenderTelemetry={this.props.applicationStore.entryPageGlobalRenderTelemetry}
                            />
                            <Switch>
                                <Route exact path={paths.home} component={EventListRoute} />
                                <Route path={paths.search} component={SearchContainer} />
                                <Route path={paths.eventDetail} component={EventDetailRouteContainer} />
                                <Route path={paths.favoriteDetails} component={FavoriteDetailsRouteContainer} />
                                <Route path={paths.calendar} component={CalendarRouteContainer} />
                                <Route path={paths.ticketList} component={LiveTicketListContainer} />
                                {__IsMTSTipos__ && <Route path={paths.ticketWinList} component={LiveTicketWinListContainer} />}
                                {!__IsMTSTipos__ && <Route path={paths.ticketListVG} component={LiveTicketListForVGContainer} />}

                                <Route path={paths.ticketDetail} component={TicketDetailMyTicketLiveContainer} />

                                {!__IsMTSTipos__ && <Route path={paths.ticketDetailPublic} component={TicketDetailPublicTicketLiveContainer} />}
                                {!__IsMTSTipos__ && <Route path={paths.legacyTicketDetailPublic} component={TicketDetailLegacyPublicTicketLiveContainer} />}
                                {!__IsMTSTipos__ && <Route path={paths.ticketDetailByNumber} component={TicketDetailTicketByNumberLiveContainer} />}
                                {!__IsMTSTipos__ && <Route path={paths.ticketDetailVG} component={LiveTicketDetailMyTicketForVGContainer} />}

                                {__IsMTSTipos__ && <Route path={paths.legacyTicketDetailForTipos} component={LegacyBetDetailLiveRoute} />}
                                {__IsMTSTipos__ && <Route path={paths.legacyTicketDetailPublic} component={LegacyPublicBetDetailLiveRoute} />}
                                <Redirect to={paths.home} />
                            </Switch>
                        </div>
                        <SimpleBar
                            className={`live-right-container scroll-container hide-x-bar`}
                            forceVisible={true} scrollToTop
                        >
                            <div className="right-container-content" data-test-role="right-column"> {/* same app.tsx and liveApp.tsx */}
                                <MatchTrackerWithSelection
                                    availableEvents={this.store.events.eventsWithMatchTracker}
                                    info={this.store.events.rightSideStreamWrapper.matchTracker}
                                    showType={this.store.events.rightSideStreamWrapper.showType}
                                    onOpen={(item: IMatchTrackerSelectionItem) => this.store.events.rightSideStreamWrapper.open(item)}
                                    onClose={() => { this.store.events.rightSideStreamWrapper.close(); }}
                                    matchTrackerKey={this.store.settingsProvider.matchTrackerKey}
                                />
                                <RightColumnTicketAreaWrapper
                                    ticketWrapper={this.store.ticketWrapper}
                                    todayTickets={this.store.todayTickets}
                                    cashOutList={this.store.cashOutList}
                                    isLive={true}
                                    reloadCashoutOnError={() => { this.store.subscribeToMtsCashoutAsync(); }}
                                    goToEventDetail={(eventId: number, offerType: OfferType) => {
                                        if (offerType === OfferType.Prematch) {
                                            routing.redirectToPrematchEventDetailFromLive({ eventKey: `${eventId}` });
                                        } else {
                                            routing.pushToEventDetail(eventId);
                                        }
                                    }}
                                    goToTicketDetail={pushToTicketDetail}
                                />
                                {!__IsMTSTipos__ && <FindTicketByNumberContainer
                                    store={this.store.findTicketNumber}
                                    pushToTicketDetailByNumber={pushToTicketDetailByNumber}
                                />
                                }

                                {
                                    this.props.applicationStore.settingsProvider.mobileCodeAdvert &&
                                    <MobileAppLinkAdvert mobileCodeAdvert={this.props.applicationStore.settingsProvider.mobileCodeAdvert} />
                                }

                                {__IsMTSTipos__ && <MarketingActionContainer
                                    store={this.store.marketingAction}
                                />}

                                {(this.store.chat.canShowChat) &&
                                    <ChatContainer
                                        chatStore={this.store.chat}
                                        subscribeMessagesAgain={() => { this.store.subscribeToChatAsync(); }}
                                    />
                                }

                                <RightBannersContainer />

                                {/* TODOHT column wrapper, maybe already exists */}
                            </div>
                            {devLogService.isEnabled() && <DevLog />}
                        </SimpleBar>
                    </div>
                </ErrorBoundary>
            </Router>
        );
    }

    componentDidCatch(error: Error, info: Object) {
        this.store.saveError(error, info, false);
    }

    componentWillUnmount() {
        this.isUnmounted = true;
        clearInterval(this.refreshEventsTimer);
    }
}
